export default __webpack_public_path__ + "static/media/rock-fruits.17c3a73f.png";